import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { ShoppingBag, Search, Package, CreditCard, Truck, BarChart3, Check, ArrowRight } from "lucide-react";

const ECommercePage = () => {
  const features = [
    {
      icon: Search,
      title: "Akıllı Ürün Arama",
      desc: "Müşterileriniz sesli olarak ürün arar, filtreler ve karşılaştırır. AI, stok durumunu kontrol eder, alternatif ürünler önerir.",
    },
    {
      icon: ShoppingBag,
      title: "Sesli Sipariş",
      desc: "Müşteriler sesli komutla sepete ürün ekler, sipariş oluşturur ve ödeme adımına geçer. Tüm süreç eller serbest, doğal konuşma ile.",
    },
    {
      icon: Package,
      title: "Sipariş Takibi",
      desc: "Müşteriler sipariş durumunu sorgular, kargo takip numarasını öğrenir. İptal ve iade taleplerini sesli olarak başlatır.",
    },
    {
      icon: Truck,
      title: "Kargo & Lojistik Entegrasyonu",
      desc: "Trendyol, Yemeksepeti, Shopify, WooCommerce gibi platformlarla entegre. Stok, sipariş ve kargo bilgisi anlık senkronize edilir.",
    },
    {
      icon: CreditCard,
      title: "Ödeme ve Fatura",
      desc: "Geçmiş siparişleri listeler, fatura bilgilerini paylaşır. İade sürecini başlatır ve iade durumunu takip eder.",
    },
    {
      icon: BarChart3,
      title: "Satış Analitiği",
      desc: "En çok sorulan ürünler, en sık yapılan şikayetler ve müşteri memnuniyet trendleri hakkında haftalık raporlar.",
    },
  ];

  const hero = (
    <PageHero
      eyebrow="Ürün"
      title="E-Ticaret Asistanı"
      subtitle="Online mağazanız için 7/24 çalışan sesli ve yazılı AI asistan. Ürün arama, sipariş, kargo takibi ve iade süreçlerini otomatikleştirin."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/pages/online-shopping.jpg" alt="E-ticaret alışveriş" height="360px" />
      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-[28px] font-bold mb-4" style={{ color: "var(--fg)" }}>E-ticaret operasyonlarınızı AI'a devredin</h2>
            <p className="text-[15px] leading-relaxed max-w-2xl mx-auto" style={{ color: "var(--fg)", opacity: 0.85 }}>
              Müşterileriniz WhatsApp, Instagram veya web siteniz üzerinden sipariş verebilir, sorgulama yapabilir. AI asistanınız tüm kanallarda tutarlı ve hızlı hizmet verir.
            </p>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
              {features.map((f) => (
                <div key={f.title} className="p-6 rounded-2xl transition-colors duration-200" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <f.icon size={22} />
                  </div>
                  <h3 className="text-[16px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{f.title}</h3>
                  <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{f.desc}</p>
                </div>
              ))}
            </div>
            <div className="mt-12 rounded-2xl overflow-hidden" style={{ border: "1px solid var(--border)" }}>
              <img
                src="/images/pages/package-delivery.jpg"
                alt="Kargo ve lojistik"
                className="w-full h-auto object-cover"
                style={{ maxHeight: "340px" }}
                loading="lazy"
              />
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-4xl mx-auto">
            <h2 className="text-[28px] font-bold mb-10 text-center" style={{ color: "var(--fg)" }}>Entegre Platformlar</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {["Trendyol", "Shopify", "WooCommerce", "Yemeksepeti", "Getir", "Hepsiburada", "Amazon", "Magento"].map((p) => (
                <div key={p} className="flex items-center gap-2 p-3 rounded-xl" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
                  <Check size={14} style={{ color: "#10b981", flexShrink: 0 }} />
                  <span className="text-[13px] font-medium" style={{ color: "var(--fg)" }}>{p}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6 text-center">
          <a href="https://app.verasist.ai" className="inline-flex items-center gap-2 px-10 py-4 rounded-full font-bold text-[15px] transition-all duration-200" style={{ background: "var(--brand-navy)", color: "#fff" }}>
            E-Ticaret Asistanı Kurun <ArrowRight size={18} />
          </a>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default ECommercePage;
